import React from "react";
import { FormControl, InputGroup } from "react-bootstrap";

function Comments({ setFormData, length, comment }) {
  const handleComment = (event) => {
    const comments = event.target.value;
    setFormData((prevFormData) => ({
      ...prevFormData,
      comments: comments,
    }));
  };
  return (
    <>

      <InputGroup className='d-flex'>
        <InputGroup.Text className='flex-1'>
          <div className='d-flex flex-column align-items-start gap-1'>
            <h4 className='p-0 m-0'>
              Comment
            </h4>
            <span style={{ fontSize: 11 }} className="text-danger ">
              {length < 6 && length ? `Add ${6 - length} characters` : length ? "" : `Minimum 6 Characters comment required`}
            </span>
          </div>
        </InputGroup.Text>
        <FormControl className='flex-1' as="textarea" aria-label="Product Reaction" onChange={handleComment} defaultValue={comment} />
      </InputGroup>
    </>

  );
}

export default Comments;
